import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`
// let baseUrl = '/api/kj-gy-apartment'

let api = {
  // 修改背景图和图标
  addImage: `${baseUrl}/wxCardBag/addImage`,

  // 获取背景图和图标
  getWXCardBag: `${baseUrl}/wxCardBag/getWXCardBag`,

  // 获取导航栏列表
  getFieldList: `${baseUrl}/wxCardBag/getFieldList`,

  // 修改导航栏列表
  addField: `${baseUrl}/wxCardBag/addField`,

  // 获取二维码图片
  deleteNavigateByCodes: `${baseUrl}/wxCardBag/getQrCode`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/ConfigCardWx.js